// This file is in commonjs format because it is used to generate locale (e.g. by scripts/translate.js)

const defaultLocale = 'en';
const supportedLocales = ['fr', 'en', 'de', 'es', 'it', 'pt', 'nl'];
const countryToDefaultLocale = (country) => (country === 'GB' ? 'en' : country === 'AT' ? 'de' : country.toLowerCase());
const supportedCountries = ['FR', 'DE', 'ES', 'GB', 'IT', 'PT', 'NL', 'LU', 'BE', 'AT'];
const translatedLocales = supportedLocales.filter((locale) => locale !== defaultLocale);

module.exports = { defaultLocale, supportedLocales, countryToDefaultLocale, translatedLocales, supportedCountries };
